export default {
  uploadImageFrom: '',
  addNewFolder: 'Add a new folder',
};
